import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { SearchSchema } from "./-schemas";

export const Route = createFileRoute(
  "/_staff/apps/_list/marketplace/$id/install/finish/",
)({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => ({ search }),
  beforeLoad: ({ search }) => {
    const appIntegrationId = search.appIntegrationId;
    if (search.result === "success" && appIntegrationId) {
      throw redirect({
        to: `/app-integrations/$id`,
        params: { id: appIntegrationId },
      });
    }
  },
});
